// Shared permission mappings and helpers
export const rolePermissions = {
  admin: {
    create_forms: true,
    set_schedules: true,
    approve_submissions: true,
    manage_users: true,
    conduct_checks: true,
    view_submissions: true,
    view_policies: true,
    manage_policies: true,
  },
  manager: {
    create_forms: false,
    set_schedules: true,
    approve_submissions: true,
    manage_users: false,
    conduct_checks: true,
    view_submissions: true,
    view_policies: true,
    manage_policies: false,
  },
  user: {
    create_forms: false,
    set_schedules: false,
    approve_submissions: false,
    manage_users: false,
    conduct_checks: true,
    view_submissions: true,
    view_policies: true,
    manage_policies: false,
  },
  viewer: {
    create_forms: false,
    set_schedules: false,
    approve_submissions: false,
    manage_users: false,
    conduct_checks: false,
    view_submissions: true,
    view_policies: true,
    manage_policies: false,
  },
};

/**
 * Determine whether a user object has a named permission.
 * @param {object|null} userData - user document (should include `role` and optional `customRoles`)
 * @param {string} permission - permission key (e.g. 'create_forms')
 */
export function hasPermission(userData, permission) {
  if (!userData) return false;
  if (userData.role === 'admin') return true;

  // Normalize role and custom roles to handle variants like 'super-user'
  const roleKeyRaw = String(userData.role || 'user').toLowerCase();
  const roleKey = roleKeyRaw.replace(/[_\s-]+/g, ''); // e.g. 'super-user' -> 'superuser'

  // Check customRoles for supervisor-like entries
  const custom = (userData.customRoles || []).map(r => String(r).toLowerCase());
  const customNormalized = custom.map(c => c.replace(/[_\s-]+/g, ''));
  if (customNormalized.includes('super') || customNormalized.includes('superuser') || customNormalized.includes('superuser')) {
    return !!(rolePermissions.manager && rolePermissions.manager[permission]);
  }

  // Treat role variants 'super', 'superuser', 'super-user' as manager (Super User)
  if (['super', 'superuser', 'manager'].includes(roleKey)) {
    return !!(rolePermissions.manager && rolePermissions.manager[permission]);
  }

  return !!(rolePermissions[roleKey] && rolePermissions[roleKey][permission]);
}

export default { rolePermissions, hasPermission };
